export const R_ERROR_500 = 'Server error!';

export const V_INVALID_EMAIL = 'Incorrect email format';
export const V_INVALID_PASSWORD = 'Passwords must contain at least 8 characters';
export const V_FIELD_REQUIRED = 'This field is required';
